import { findLast } from 'lodash';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { GregorioType } from '../../gregorio-chant/enums/GregorioType';
import { ChantSyllableElement } from '../containers/ChantSyllableElement';
import { Glyph } from '../glyphs/Glyph';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { calculateHeightPositionFromPitch } from '../utils';
import { GlyphVisualizer } from '../visualizers';

export class Custos extends ChantLayoutElement {
  _visualizer: GlyphVisualizer;

  // if auto is true, then the custos will automatically try to determine it's height based on
  // subsequent notations
  constructor(
    context: ChantContext,
  ) {
    super(context);
    const glyph = new Glyph('CustosUpLong', this._context.gabcFont, this._context.gabcGlyphSize);
    this._visualizer = new GlyphVisualizer(context, glyph, this._context.gabcColor);
  }

  public performLayout(): void {
    this.bounds.setWidth(this._visualizer.bounds.width);
  }

  public setX(x: number): void {
    this._visualizer.bounds.setX(x);
    this._visualizer.setTextAnchor('end');
  }

  public setHeightFromNotations(syllables: ChantSyllableElement[], startIndex: number) {
    const backwardSyllables = syllables.slice(0, startIndex);
    const forwardSyllables = syllables.slice(startIndex);

    const clefSyl = findLast(backwardSyllables, (syl) => syl.hasClef);

    let sylIndex = 0;
    for (const syllable of forwardSyllables) {
      for (const segment of syllable.segments) {
        for (const glyph of segment.noteVisualizers) {
          if (glyph.notes.length > 0) {
            const noteClefSyl = findLast(syllables.slice(0, startIndex + sylIndex + 1), (syl) => syl.hasClef);
            let pitch = glyph.notes[0].pitch;
            if (clefSyl!.clef.gabc.misc.clef.line !== noteClefSyl!.clef.gabc.misc.clef.line) {
              pitch = pitch +
                (clefSyl!.clef.gabc.misc.clef.line - noteClefSyl!.clef.gabc.misc.clef.line) * 2;
            }
            this._visualizer.bounds.setY(
              calculateHeightPositionFromPitch(this._context, pitch));
            return;
          }
        }
      }
      sylIndex++;
    }
  }

  public setHeightFromPitch(pitch: number): void {
    this._visualizer.bounds.setY(
      calculateHeightPositionFromPitch(this._context, pitch));
  }

  public createSvgFragments(): SVGElement[] {
    return [
      ...this._visualizer.createSvgFragments(),
    ];
  }
}
